module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7r6r5r1r-038135dc75ed2795ce6447a86a888a30.svg";